import { render, staticRenderFns } from "./borrowerBusinessCard.vue?vue&type=template&id=09e179f6&"
import script from "./borrowerBusinessCard.vue?vue&type=script&lang=js&"
export * from "./borrowerBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./borrowerBusinessCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports